module.exports = __webpack_public_path__ + "img/cc-stripe-button.e95f2d63.png";